import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/home/home.css";
import "../../styles/cto/cto-stats.css";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectAuth } from "../../components/auth/auth.selector";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";
import CTOCards from "../../components/cto-stats/CTOCards";
import { fetchCtoStatsData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
} from "../../components/common-data/Converts";
import { formatNumber } from "../../utils/utilityfunc";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import GymTarAssign from "./common/GymTarAssign";
import CTODetail from "./CTODetail";
import HelmetWrapper from "../../HelmetWrapper";
import { calcDailyTarget2 } from "../../components/common-data/Calculations";
import CTOHeadCategoryTabs from "./CTOHeadCategoryTabs";

const CTOStats = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const dispatch = useDispatch();
  const { loading, ctoStats, error } = useSelector((state) => state.api);

  const iniAllFilters = {
    selectedGym: "",
    selectedYear: { label: currentYear, value: currentYear },
    selectedMonth: { label: currentMonthName, value: currentMonthNumber },
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    month: "",
    year: "",
    gym_id: "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniTbDatas = {
    allData: null,
    stats: {},
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    isModOpen: false,
    name: "",
    rowData: {},
    cardType: "",
    gymId: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  const onClickValues = (e, name, row) => {
    e.preventDefault();

    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      name: name,
      rowData: row,
      gymId: row?.gym_id,
      cardType: name,
    }));
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      month: allFilters.selectedMonth?.value
        ? allFilters.selectedMonth.value
        : "",
      year: allFilters.selectedYear?.value ? allFilters.selectedYear.value : "",
      gym_id: allFilters.selectedGym?.value ? allFilters.selectedGym.value : "",
    }));
  }, [allFilters]);

  useEffect(() => {
    if (filters.month) {
      dispatch(
        fetchCtoStatsData({
          filters: filters,
          token: user?.token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (ctoStats?.status && !error) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: ctoStats?.data || [],
        stats: ctoStats?.stats || {},
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [ctoStats, error]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "total_cto",
      text: "Total CTO",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 hoverBlue hoverUnderline"
            style={{
              cursor: "pointer",
              fontWeight: "700",
            }}
            onClick={(e) => {
              onClickValues(e, "cto-detail", row);
            }}
          >
            ₹{row?.total_cto ? convertThenFormat(row.total_cto) : 0}
            <br />
            <small
              style={{
                fontSize: "12px",
                color: row?.cto_acheived_per <= 0 ? "#CD0909" : "#379C00",
              }}
            >
              {row?.cto_acheived_per
                ? convertThenFormat(row.cto_acheived_per)
                : 0}
              % Completed
            </small>
          </span>
        );
      },
    },
    {
      dataField: "target_acheived",
      text: "Today's Target",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background: "#F3DADA",
              color: "#D90000",
            }}
          >
            ₹
            {row?.target_acheived || row?.target_value
              ? formatNumber(
                  calcDailyTarget2(row?.target_value, row?.target_acheived)
                )
              : 0}
          </span>
        );
      },
    },
    {
      dataField: "target_value",
      text: "Gym Target",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.target_value) || 0}
          </span>
        );
      },
    },
    {
      dataField: "target_acheived",
      text: "Target Achieved",
      formatter: (_, row) => {
        const isAbove = row?.target_value
          ? parseInt(row?.target_acheived) >= parseInt(row?.target_value)
          : true;
        const difference = row?.target_value
          ? parseInt(row?.target_acheived || 0) -
            parseInt(row?.target_value || 0)
          : null;

        return (
          <div
            className="emeberDetailsRowContainer column"
            style={{ gap: "0" }}
          >
            <span className="tb-data minWidth150">
              ₹{convertThenFormat(row?.target_acheived) || 0}
              {isAbove ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#209216" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#E41815" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              )}
              <br />
              <small
                style={{
                  color: difference < 0 ? "#CD0909" : "#379C00",
                }}
              >
                {row?.target_remaining < 0 ? "+" : "-"}
                {row?.target_remaining || 0}
              </small>
            </span>
            <span
              className="tb-data"
              style={{
                fontSize: "12px",
                color:
                  parseFloat(row?.total_acheive_per || 0) <= 0
                    ? "#CD0909"
                    : "#379C00",
              }}
            >
              {parseFloat(row?.total_acheive_per || 0)?.toFixed()}% Completed
            </span>
          </div>
        );
      },
    },
    {
      dataField: "regular_target",
      text: "Regular Target",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.regular_target) || 0}
          </span>
        );
      },
    },
    {
      dataField: "regular_acheived",
      text: "Regular Target Achieved",
      formatter: (_, row) => {
        const isAbove = row?.regular_target
          ? parseInt(row?.regular_acheived) >= parseInt(row?.regular_target)
          : true;
        const differenceRegular = row?.regular_target
          ? parseInt(row?.regular_acheived || 0) -
            parseInt(row?.regular_target || 0)
          : 0;

        return (
          <div
            className="emeberDetailsRowContainer column"
            style={{ gap: "0" }}
          >
            <span className="tb-data minWidth150">
              ₹{convertThenFormat(row?.regular_acheived) || 0}
              {isAbove ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#209216" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#E41815" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              )}
              <br />
              <small
                style={{
                  color: differenceRegular < 0 ? "#CD0909" : "#379C00",
                }}
              >
                {differenceRegular > 0 ? "+" : null} {differenceRegular || 0}
              </small>
            </span>
            <span
              className="tb-data"
              style={{
                fontSize: "12px",
                color:
                  parseFloat(row?.regular_acheive_per || 0) <= 0
                    ? "#CD0909"
                    : "#379C00",
              }}
            >
              {parseFloat(row?.regular_acheive_per || 0)?.toFixed()}% Completed
            </span>
          </div>
        );
      },
    },
    {
      dataField: "pt_target",
      text: "PT Target",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.pt_target) || 0}
          </span>
        );
      },
    },
    {
      dataField: "addon_pt_acheived",
      text: "PT Target Achieved",
      formatter: (_, row) => {
        const isAbove = row?.pt_target
          ? parseInt(row?.addon_pt_acheived) >= parseInt(row?.pt_target)
          : true;
        const differenceRegular = row?.pt_target
          ? parseInt(row?.addon_pt_acheived || 0) -
            parseInt(row?.pt_target || 0)
          : 0;

        return (
          <div
            className="emeberDetailsRowContainer column"
            style={{ gap: "0" }}
          >
            <span className="tb-data minWidth150">
              ₹{convertThenFormat(row?.addon_pt_acheived) || 0}
              {isAbove ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-up-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#209216" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-down-short"
                  viewBox="0 0 16 16"
                  style={{ color: "#E41815" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                  />
                </svg>
              )}
              <br />
              <small
                style={{
                  color: differenceRegular < 0 ? "#CD0909" : "#379C00",
                }}
              >
                {differenceRegular > 0 ? "+" : null} {differenceRegular || 0}
              </small>
            </span>
            <span
              className="tb-data"
              style={{
                fontSize: "12px",
                color:
                  parseFloat(row?.pt_acheive_per || 0) <= 0
                    ? "#CD0909"
                    : "#379C00",
              }}
            >
              {parseFloat(row?.pt_acheive_per || 0)?.toFixed()}% Completed
            </span>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={(e) => {
              onClickValues(e, "edit", row);
            }}
            style={{ border: "none", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: CTO Stats">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={clickValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Target Assign Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer cloud-bg-k borderRadiusTen`}
          >
            {clickValues.cardType !== "cto-categories-and-heads" && (
              <ModalHeadAndClose
                title={`${
                  clickValues.cardType === "edit"
                    ? "Target Assign"
                    : clickValues.cardType === "cto-detail"
                    ? "CTO Detail"
                    : clickValues.cardType === "cto-categories-and-heads"
                    ? "Manage CTO Categories and Heads"
                    : clickValues.cardType?.replace(/-/g, " ")
                }`}
                onClose={onCloseModal}
              />
            )}

            {clickValues.cardType === "edit" ? (
              <GymTarAssign
                user={user}
                allFilters={allFilters}
                closeModal={onCloseModal}
                callFunction={() =>
                  dispatch(
                    fetchCtoStatsData({
                      filters: filters,
                      token: user?.token,
                    })
                  )
                }
                rowData={clickValues.rowData}
              />
            ) : clickValues.cardType === "cto-detail" ? (
              <CTODetail
                user={user}
                prevFilters={filters}
                gymId={clickValues.gymId}
                rowData={clickValues.rowData}
              />
            ) : clickValues.cardType === "cto-categories-and-heads" ? (
              <CTOHeadCategoryTabs
                userInfoData={user}
                onCloseModal={onCloseModal}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"CTO Stats"}
              createBtnTxt={"+ Add Month Target"}
              createBtnTxt1={"Reload"}
              onClickCreateBtn={(e) => onClickValues(e, "edit", {})}
              onClickCreateBtn1={() =>
                dispatch(
                  fetchCtoStatsData({
                    filters: filters,
                    token: user?.token,
                  })
                )
              }
              // createBtnTxt2={"Manage CTO Categories and Head"}
              // onClickCreateBtn2={(e) =>
              //   onClickValues(e, "cto-categories-and-heads", {})
              // }
              isLoading={loading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from="cto-stats"
              decryptedText={user}
              setFilters={setAllFilters}
              filters={allFilters}
              onClickReset={onClickReset}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CTOCards stats={tbDatas.stats} />
          </Col>
        </Row>

        <Row>
          <Col>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <div className="overflowAuto separatedTable mt-0">
                <PaymentLinkTable
                  tableData={tbDatas.allData}
                  tableColumns={tbColumns}
                />
              </div>
            )}
          </Col>
        </Row>
        <br />
      </Container>
    </HelmetWrapper>
  );
};

export default CTOStats;
